








import {
  Component,
  Emit,
  Prop,
  Vue,
} from 'vue-property-decorator';
import ClearIconButton from '@/browser/atoms/ClearIconButton.vue';
import ImagePreview from '@/browser/atoms/ImagePreview.vue';
import UploadIconButton from '@/browser/atoms/UploadIconButton.vue';

@Component({
  components: {
    ClearIconButton,
    ImagePreview,
    UploadIconButton,
  },
})
export default class ImageEditor extends Vue {
  @Prop() url?: string;

  @Emit('upload')
  emitUpload(file: File) {}

  onInput(file: File | null) {
    if (file) this.emitUpload(file);
  }
}
